export const USE_QUESTIONNAIRE_SELECTOR_URL_SEARCH_PARAM = 'useQuestionnaireSelector';
export const PARTNER_URL_SEARCH_PARAM = 'partner';
export const PROVIDER_URL_SEARCH_PARAM = 'provider';
export const CONDITION_URL_SEARCH_PARAM = 'condition';
export const SUB_CONDITION_URL_SEARCH_PARAM = 'sub_condition';
export const CUSTOMER_REF_URL_SEARCH_PARAM = 'customerRef';
export const NEW_PROFILE_URL_SEARCH_PARAM = 'newProfile';
export const VISITED_AI_PAGE_URL_SEARCH_PARAM = 'visit_ai';
export const QUESTIONNAIRE_IN_PROGRESS_URL_SEARCH_PARAM = 'inProgress';
export const SIGNUP_TYPE_URL_SEARCH_PARAM = 'type';

export const USER_TYPE_URL_SEARCH_PARAM = 'user_type';
export const START_SIGNUP_URL_SEARCH_PARAM = 'signup';
export const AFTER_SIGNUP_URL_SEARCH_PARAM = 'signup';
export const REDIRECT_URL_SEARCH_PARAM = 'redirect';
export const LOGIN_TOKEN_URL_SEARCH_PARAM = 'token';
export const ACCESS_TOKEN_URL_SEARCH_PARAM = 'tj_access_token';
export const REFRESH_TOKEN_URL_SEARCH_PARAM = 'tj_refresh_token';
export const AUTH_TYPE_URL_SEARCH_PARAM = 'type';
export const AUTH_EMAIL_URL_SEARCH_PARAM = 'email';
export const REMATCH_URL_SEARCH_PARAM = 'rematch';
export const PAGE_URL_SEARCH_PARAM = 'page';

export const UNANSWERED_URL_SEARCH_PARAM = 'unanswered';
export const SOURCE_URL_SEARCH_PARAM = 'source';
export const DETACH_URL_SEARCH_PARAM = 'detach';
export const OPEN_URL_SEARCH_PARAM = 'open';
export const NEWEST_URL_SEARCH_PARAM = 'newest';

export const INTAKE_SECTION_URL_SEARCH_PARAM = 'section';

export const ARTICLE_IN_IFRAME_URL_SEARCH_PARAM = 'iframe';

export const POPUP_URL_SEARCH_PARAM = 'popup';
